import { Image as ImageComponent } from 'antd';
import styled, { css, keyframes } from 'styled-components';
import { Button } from 'components/Button';
import { Close } from 'icons';
import { isMobile } from 'utils';
import { DEVICE } from 'constants/app/breakpoints';

const PopFromBottom = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const PopFromBottomClose = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;

const FtAnimations = {
  POP_FROM_BOTTOM: {
    open: PopFromBottom,
    close: PopFromBottomClose
  }
};

export const Wrapper = styled.div<{
  $withCloseIcon?: boolean;
  $isLargeWidth?: boolean;
}>`
  display: flex;
  justify-content: center;
  background: var(--v3-black-0);
  padding: 44px 44px 24px;
  border-radius: 24px;
  width: ${props => (props.$isLargeWidth ? `797px` : `560px`)};

  ${({ $withCloseIcon }) =>
    $withCloseIcon &&
    css`
      padding: 62px 52px 44px 52px;
    `}
  ${isMobile() &&
  css`
    width: 100%;
    border-radius: 0;
    padding: 32px 16px;
  `}
`;

export const TextCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media screen and ${DEVICE.xl} {
    width: 100%;
  }
`;

export const Title = styled.h3<{ $colored: boolean; $color?: string }>`
  color: ${({ $colored, $color }) => {
    if ($colored) {
      switch ($color) {
        case 'pending':
          return 'var(--v3-gold-base)';
        default:
          return 'var(--v3-primary-color)';
      }
    } else {
      return 'var(--v3-text-color)';
    }
  }};
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 16px;
  justify-content: center;
`;

export const Text = styled.p`
  text-align: center;
  color: var(--v3-text-color-secondary);
  margin-bottom: 20px;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  margin-top: 0;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  margin: 0 8px 0 8px;
  display: flex;
  justify-content: center;
  gap: 8px;

  @media screen and ${DEVICE.xl} {
    display: flex;
    flex-direction: column;
  }
`;

export const ButtonContainer = styled.div`
  flex: 1 1 0;
`;

export const ConfirmationButton = styled(Button)`
  &&& {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    height: 48px;
    overflow: initial;
  }
`;

export const PopupBody = styled.div<{ $withCloseIcon: boolean }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: fit-content;
  border-top-right-radius: 24px;
  border-top-left-radius: 24px;
  background: var(--v3-black-0);
  padding: 32px;

  ${props =>
    props.$withCloseIcon &&
    css`
      padding: 32px 24px 24px;
    `}
`;

export const Popup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.5);

  &.open {
    ${PopupBody} {
      animation: ${FtAnimations.POP_FROM_BOTTOM.open} 0.3s ease-in-out forwards;
    }
  }

  &.close {
    ${PopupBody} {
      animation: ${FtAnimations.POP_FROM_BOTTOM.close} 0.3s ease-in-out forwards;
    }
  }
`;

export const PopupCloseIcon = styled(Close)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--v3-black-1);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 28px;
`;

export const ImageWrapper = styled.div`
  margin-bottom: 20px;
`;

export const Image = styled(ImageComponent)`
  && {
    border-radius: 8px;
    overflow: hidden;
  }
`;
